import SplitPageHero from '../../split-page-hero';
import CompactItinerary from '../../compact-itinerary';
import { FeaturedProfileCard } from '../../featured-profile-card';
import ExperienceDetailsList from '../../experience-details-list';

import type { BreadcrumbItem } from '../../breadcrumb';
import type { ProductDetailData } from './types';
import type { PdpSection, ProductDetailStores } from '../shared/types';

const SECTION_IDS = {
	hero: 'experience-pdp-hero',
	itinerary: 'experience-pdp-itinerary',
	productBookingWidget: 'product-booking-widget',
	host: 'experience-pdp-host',
	experienceDetails: 'experience-pdp-experience-details',
} as const;

export function experienceSections(
	product: ProductDetailData,
	stores: ProductDetailStores,
	breadcrumb?: BreadcrumbItem[]
): PdpSection[] {
	const { hero, itinerary, host, experienceDetails } = product;
	const { userStore, productAvailabilityStore } = stores;

	const sections: (PdpSection | false | undefined)[] = [
		hero && {
			key: 'hero',
			id: SECTION_IDS.hero,
			render: () => <SplitPageHero {...hero} breadcrumb={breadcrumb} />,
		},

		!!itinerary?.steps?.length && {
			key: 'itinerary',
			id: SECTION_IDS.itinerary,
			layout: 'beside-aside',
			render: () => <CompactItinerary steps={itinerary.steps} title={itinerary.title} />,
		},

		host && {
			key: 'host',
			id: SECTION_IDS.host,
			layout: 'beside-aside',
			render: () => <FeaturedProfileCard {...host} />,
		},

		experienceDetails && {
			key: 'experience-details',
			id: SECTION_IDS.experienceDetails,
			layout: 'beside-aside',
			render: () => (
				<ExperienceDetailsList
					{...experienceDetails}
					userStore={userStore}
					productId={product.id}
					productAvailabilityStore={productAvailabilityStore}
				/>
			),
		},
	];

	return sections.filter((section): section is PdpSection => Boolean(section));
}
